// @ts-ignore
import { plugin as $date } from '~/plugins/date'

/**
 * Value augmenters for date/time field transformations.
 * Replaces: mixins/fields/augmenters.js
 *
 * These are pure functions — no Vue reactivity needed.
 */

export interface Augmenter {
  input: (value: any) => any
  output: (value: any) => any
}

export const augmenters: Record<string, Augmenter> = {
  YMD: {
    input: (value: any) => {
      if (value && !(value instanceof Date)) {
        const date = value.toString()
        if (date.length === 8) {
          const year = date.substring(0, 4)
          const month = date.substring(4, 6)
          const day = date.substring(6, 8)
          return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), 0, 0, 0, 0)
        }
      }
      return value
    },
    output: (value: any) => {
      if (value && value instanceof Date) {
        const zeroPad = (num: number) => (num < 10 ? '0' + num.toString() : num.toString())
        return value.getFullYear().toString() + zeroPad(value.getMonth() + 1) + zeroPad(value.getDate())
      }
      return value
    },
  },

  timestamp: {
    input: (value: any) => {
      if (value && !(value instanceof Date)) return new Date(value * 1000)
      return value
    },
    output: (value: any) => {
      if (value && value instanceof Date) return Math.round(value.getTime() / 1000)
      return value
    },
  },

  // Preserve date-only Unix timestamps as UTC calendar dates in every browser timezone.
  timestampUTC: {
    input: (value: any) => {
      if (value && !(value instanceof Date)) {
        const date = new Date(value * 1000)
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
      }
      return value
    },
    output: (value: any) => {
      if (value && value instanceof Date) {
        return Math.round(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()) / 1000)
      }
      return value
    },
  },

  minutes: {
    input: (value: any) => {
      if (value !== null && value !== undefined && !(value instanceof Date)) {
        return $date.minutes(value, false)
      }
      return value
    },
    output: (value: any) => {
      if (value !== null && value !== undefined && value instanceof Date) {
        return $date.getMinutes(value)
      }
      return value
    },
  },
}
